var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrinciple7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1377_248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.5492 1.56585C87.2719 -0.901994 81.7726 0.522051 79.2757 4.74945L76.9674 8.65625L73.9047 13.838L52.5185 50.043L49.4558 55.2248L45.8877 61.2639L47.1701 76.6824L61.3823 70.2108L64.9504 64.1716L68.0131 58.9899L89.3992 22.7849L92.4619 17.6031L94.7703 13.6963C97.2672 9.46893 95.8264 4.0337 91.5492 1.56585ZM57.105 65.5509L52.511 67.6385L52.0961 62.6581L54.6986 58.2518L59.7 61.1371L57.0975 65.5435L57.105 65.5509ZM62.7703 55.9629L57.7689 53.0775L79.155 16.8725L84.1564 19.7578L62.7703 55.9629ZM89.5275 10.6693L87.2191 14.5761L82.2177 11.6907L84.5261 7.78393C85.3332 6.41954 87.106 5.95728 88.4865 6.75504C89.8669 7.55281 90.3346 9.3049 89.5275 10.6693Z",
    fill: "#F6A000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2615 22.4043H29.3369V29.1145H61.2615V22.4043Z",
    fill: "#F6A000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5184 46.5981L29.3369 46.8367V53.5469L48.4449 53.5991L52.5184 46.5981Z",
    fill: "#F6A000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6327 80.1566C66.6327 85.1966 62.4837 89.2898 57.3918 89.2898H16.0302C10.9307 89.2898 6.78925 85.1892 6.78925 80.1566V15.8434C6.78925 10.8034 10.9382 6.71016 16.0302 6.71016H57.3842C62.4837 6.71016 68.0057 15.7092 68.0057 20.7493L73.0297 12.1081C73.0297 3.36999 66.2254 0 57.3842 0H16.0302C7.18906 0 0 7.10531 0 15.8434V80.1566C0 88.8947 7.18906 96 16.0302 96H57.3842C66.2254 96 73.4144 88.8947 73.4144 80.1566V52.6673L66.6252 64.2759V80.1566H66.6327Z",
    fill: "#F6A000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0041 73.6926L17.3803 76.6824L33.584 64.0747L31.0493 60.8911L18.0668 70.9862L14.0083 66.0281L10.8174 68.5854L15.0041 73.6926Z",
    fill: "#F6A000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3803 26.4232L33.584 13.8156L31.0493 10.6245L18.0668 20.7196L14.0083 15.769L10.8174 18.3188L15.0041 23.4335L17.3803 26.4232Z",
    fill: "#F6A000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0041 48.5668L17.3803 51.5491L33.584 38.9489L31.0493 35.7578L18.0668 45.8529L14.0083 40.9023L10.8174 43.4521L15.0041 48.5668Z",
    fill: "#F6A000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4802 71.2695H29.3369V77.92H46.2271L45.4802 71.2695Z",
    fill: "#F6A000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1261 71.8955L55.8984 74.2664L47.3892 77.9197H61.1261V71.8955Z",
    fill: "#F6A000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1377_248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinciple7);
export default __webpack_public_path__ + "static/media/principle_7.0492cbac9e97abbd4a1d7c53472cd94c.svg";
export { ForwardRef as ReactComponent };